import type { KudoContentObjectDetail, KudoContentObjectList } from 'models';
import { useMutation } from 'query';
import { deleteKudo } from '../../services';
import { getContentObjectId } from '../../utils';
import { useContentObjectCache } from '../cache';

type DeleteKudoContentObject = { contentObject: KudoContentObjectDetail | KudoContentObjectList };

export const useDeleteKudoContentObjectMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<DeleteKudoContentObject, DeleteKudoContentObject>({
    async mutationFn(object) {
      await deleteKudo({ routeParams: { id: getContentObjectId(object.contentObject) } });

      return object;
    },
    onSuccess(_data, { contentObject }) {
      cache.remove(contentObject);
    },
  });
};
